/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ portal: NonNullable<unknown> }} Jobs_Title_Portal_MappingInputs */

const cs_jobs_title_portal_mapping = /** @type {(inputs: Jobs_Title_Portal_MappingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Mapování ID · ${i?.portal}`)
};

const en_jobs_title_portal_mapping = /** @type {(inputs: Jobs_Title_Portal_MappingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ID mapping · ${i?.portal}`)
};

/**
* | output |
* | --- |
* | "ID mapping · {portal}" |
*
* @param {Jobs_Title_Portal_MappingInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const jobs_title_portal_mapping = /** @type {((inputs: Jobs_Title_Portal_MappingInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Jobs_Title_Portal_MappingInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_jobs_title_portal_mapping(inputs)
	return cs_jobs_title_portal_mapping(inputs)
});